/**
 * 配置信息--仓库设备查询，copy 设备快速查询 stubList.js
 */

import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import { Button, Modal, message } from "antd";
import PropTypes from "prop-types";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
/**
 * 引入设备状态列表
 */
import StubStruts from "@/utils/stubStruts";
// 引入接口
import {
  getModelNoList,
  getFrameWorkList,
  getUpdateTypeList,
  getDepotStubInfoList,
  stubRestart,
  getStubInfoList,
  prefixFile,
} from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import RefreshGrid from "../../../utils/refreshGrid";
import StubDetailInfo from "./stubDetailInfo";
import StubStatusUpdate from "./stubStatusUpdate";
import StubParamsConfig from "./stubParamsConfig";
import FrameWorkUpdate from "./frameWorkUpdate";
import GetFrameWorkEdition from "./getFrameWorkEdition";
import StubStatusLog from "./stubStatusLog";
import UpdateProgress from "./updateProgress";
import { useAuth } from "@/utils/utils";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class WareSourceStubList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    console.log(this.props.intl);
    this.yunwei = this.props.intl.messages.commonBase;
    this.init();
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      visible: false,
      xhList: [],
      formConfig: null,
      stubInfoData: null,
      tableParam: {
        stubGroupName: this.queryStubName,
        meterModuleId: this.queryMeterModuleId,
        stubId: this.queryStubId,
      },
      typeOption: [
        {
          text: this.props.intl.messages.commonBase.wz10, // '全部',
          value: "",
        },
      ],
      currentParam: {},
    };
  }

  /**
   * 页面加载前调用方法，初始化查询form表单
   */
  componentWillMount() {
    /**
     * 设备状态定义
     */
    this.stateOption = StubStruts();
    /**
     * 初始化form查询表单
     */
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  /**
   * 页面加载完成调用方法，表格数据加载，并且初始化值
   */
  componentDidMount() {
    this.fetchApi(this.state.tableParam);
    this.setState({
      stubGroupName: "",
      meterModuleId: "",
      stubId: "",
    });
  }

  /**
   * 查询form表单初始化
   */
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder1, // .'请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          defaultValue: this.queryStubId,
          labelName: this.internationalization.title1, // '设备编号:',
          required: false,
        },
        {
          type: "select",
          options: [
            {
              text: this.yunwei.wz10, // '全部',
              value: "",
            },
            {
              text: this.internationalization.title20, // '交流电',
              value: "0",
            },
            {
              text: this.internationalization.title21, // '直流电',
              value: "1",
            },
            {
              text: this.internationalization.title22, // '交直流',
              value: "2",
            },
          ],
          placeholder: this.internationalization.title8, // '请选择设备类型',
          param: {
            name: "stubType",
            type: "string",
          },
          labelName: this.internationalization.title19, // '设备类型',
          required: false,
        },
        {
          type: "autoWatch",
          placeholder: this.internationalization.title10, // '请选择:',
          param: {
            name: "modelNo",
            type: "string",
          },
          labelName: this.internationalization.title11, // '设备型号',
          required: !1,
          sourceApi: getModelNoList,
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              placeholder: this.internationalization.title15, // '固件型号:',
              width: "95px",
              param: {
                name: "updateType",
                type: "string",
              },

              labelName: this.internationalization.wz3, // '固件信息','固件信息:',
              dataApi: { api: getUpdateTypeList, loaded: !1, addAll: true },
              required: false,
              onChange: async (value, form) => {
                form.setFieldsValue({
                  frameWork: "",
                  updateType: value,
                });
                fetchHandler(getFrameWorkList, {
                  updateType: value,
                }).then((res) => {
                  const finalData = res.data;
                  finalData.unshift("全部");
                  this.setState(
                    {
                      xhList: finalData.map((v) => {
                        return {
                          text: v,
                          value: v,
                        };
                      }),
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                });
              },
            },
            {
              type: "select",
              placeholder: this.internationalization.title13, // '固件版本:',
              width: "95px",
              param: {
                name: "frameWork",
                type: "string",
              },
              options: this.state.xhList,
              required: false,
            },
          ],
        },

        {
          type: "select",
          placeholder: this.internationalization.title8, // '请选择设备状态',
          labelName: this.internationalization.title27, // '设备状态',
          param: {
            name: "stubStatus",
            type: "string",
          },
          options: this.stateOption,
          required: false,
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("010301")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.title16, // '查询'
                }
              : "",
            useAuth("010302")
              ? {
                  btnType: "button",
                  text: "导出", // '导出',
                  handler: (e, param) => {
                    const newParam = param;
                    let paramString = "";
                    Object.keys(newParam).forEach((key) => {
                      const paraminfo = newParam[key] ? newParam[key] : "";
                      paramString += `${key}=${paraminfo}&`;
                    });
                    this.exportOrderStuGroup(paramString);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      defaultParams: {
        stubGroupName: this.queryStubId,
        // powerBoxId: localStorage.meterModuleId,
        meterId: this.queryMeterModuleId,
        stubId: this.queryStubId,
      },

      context: this,
      tableKey: "wareSourceStubSearchTable",
      tablePage: "设备快速查询",
    };
    return formConfig;
  };

  exportOrderStuGroup = (paramString) => {
    const excelUrl = `${prefixFile}/exportStubDepotStubInfoList.do`;

    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  /**
   *
   * 表格初始化
   */
  init = () => {
    this.queryStubId = "";
    this.queryStubName = "";
    this.queryStubGroupId = "";
    this.queryMeterModuleId = "";

    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.queryStubId = window.LayoutTab.tabParam.stubId ? window.LayoutTab.tabParam.stubId : "";
      this.queryStubName = window.LayoutTab.tabParam.StubName
        ? window.LayoutTab.tabParam.StubName
        : "";
      this.queryStubGroupId = window.LayoutTab.tabParam.stubGroupId
        ? window.LayoutTab.tabParam.stubGroupId
        : "";
      this.queryMeterModuleId = window.LayoutTab.tabParam.meterModuleId
        ? window.LayoutTab.tabParam.meterModuleId
        : "";
    }

    this.tableConfig = {
      tableKey: "wareSourceStubSearchTable",
      tableColumns: [
        {
          name: this.internationalization.title1, // '设备编号',
          key: "key",
          colType: "textCol",
          align: "left",
        },
        {
          name: this.internationalization.title19, // '设备类型'
          key: "type",
          align: "left",
          colType: "textCol",
          render: (value) => {
            switch (value) {
              case 0:
                return this.internationalization.title20; // '交流电';
              case 1:
                return this.internationalization.title21; // '直流电';
              case 2:
                return this.internationalization.title22; // '交直流';
              default:
                return this.internationalization.title23; // '未知'
            }
          },
        },
        {
          name: this.internationalization.title24, // '设备型号',
          key: "modelNo",
          colType: "textCol",
          align: "left",
        },
        {
          name: this.internationalization.wz3, // '固件信息',
          key: "updateType",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            if (value === "--") {
              return "--";
            } else {
              if (row.smallVersion !== "--" && row.smallVersion !== "" && row.smallVersion) {
                return `${value}-${row.frameWork}-${row.smallVersion}`; // 增加小版本号
              } else {
                return `${value}-${row.frameWork}`; // 增加小版本号
              }
            }
          },
        },
        {
          name: this.internationalization.title27, // '设备状态',
          key: "statusName",
          colType: "textCol",
          align: "left",
          render: (text, res) => {
            return (
              <div>
                {text}{" "}
                {text === "升级中" ? (
                  <a
                    onClick={() => {
                      this.stubInfoData = res;
                      this.setState({
                        progressVisible: true,
                      });
                    }}>
                    进度
                  </a>
                ) : null}
              </div>
            );
          },
        },
        {
          name: this.internationalization.action, // '操作',
          key: "action",
          fix: "right",
          width: 320,
          colType: "action",
          actionMap: [
            useAuth("010303")
              ? {
                  type: "href",
                  actionName: this.internationalization.wz5, // '配置信息',
                  handler: (record) => {
                    this.setState({
                      seeParamsConfigVisible: true,
                      stubId: record.key,
                      stubGroupName: record.stubGroupName,
                      devType: record.type,
                    });
                  },
                }
              : "",
            useAuth("010304")
              ? {
                  type: "href",
                  actionName: this.internationalization.btn4, // '基础信息',
                  handler: (res) => {
                    this.openTab(
                      {
                        stubId: res.key,
                        isWare: true,
                      },
                      {
                        key: "stubBasicInfo",
                        titleText: this.internationalization.btn4,
                      },
                    );

                    // this.stubInfoData = res;
                    // this.modalVisibleAction('seeDetailVisible', true);
                    // this.setState({
                    //   seeDetailVisible: true
                    // })
                  },
                }
              : "",
            useAuth("010305")
              ? {
                  type: "href",
                  actionName: this.internationalization.wz6, // '模块信息',
                  handler: (record) => {
                    this.openTab(
                      {
                        keyId: `moduleInfo${record.key}`,
                        stubId: record.key,
                      },
                      {
                        key: "moduleInfo",
                        titleText: this.internationalization.wz6, // '模块信息',
                      },
                    );
                  },
                }
              : "",
            useAuth("010306")
              ? {
                  type: "href",
                  actionName: this.internationalization.btn5, // '订单信息',
                  handler: (record) => {
                    this.openTab(
                      {
                        keyId: "0501",
                        stubInfoData: record,
                      },
                      {
                        key: "0501",
                        titleText: this.internationalization.btn5, // '订单信息',
                      },
                    );
                  },
                }
              : "",
            useAuth("010307")
              ? {
                  type: "href",
                  actionName: this.internationalization.btn2, // '修改状态',
                  handler: (record) => {
                    this.setState({
                      seeStubStatusVisible: true,
                      stubId: record.key,
                      isBatch: null,
                    });
                  },
                }
              : "",
            useAuth("010308")
              ? {
                  type: "href",
                  actionName: "固件升级",
                  render: (record) => {
                    return record.statusName === "升级中" ? null : "固件升级";
                  },
                  handler: (record) => {
                    this.stubInfoData = record;
                    this.setState({
                      updateStatus: null,
                      frameWorkUpdateVisible: true,
                      stubId: record.key,
                      frameType: record.updateType,
                      frameWork: record.frameWork,
                      smallVersion: record.smallVersion, // 增加小版本号
                      isBatch: null,
                    });
                  },
                }
              : "",
            useAuth("010309")
              ? {
                  type: "href",
                  actionName: "状态日志",
                  handler: (record) => {
                    this.stubInfoData = record;
                    this.modalVisibleAction("statusLogVisible", true);
                  },
                }
              : "",
            useAuth("010310")
              ? {
                  type: "confirm",
                  actionName: "远程复位",
                  handler: (record) => {
                    fetchHandler(stubRestart, {
                      stubId: record.key,
                    }).then((res) => {
                      if (res && (res.code === "ok" || res.code === "success")) {
                        message.success("远程复位成功");
                      }
                    });
                  },
                }
              : "",
          ],
        },
      ],
      tableParam: {
        pageCount: 10,
      },
      dataApi: getDepotStubInfoList,
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
  };

  /**
   * 页面内调用，关闭modal弹窗方法
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 传递给modal弹窗内组件子方法，关闭modal弹窗方法
   */
  cancelModal(key) {
    this.setState({
      [key]: false,
    });
  }

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
    // this.props.handle && this.props.handle()
  };

  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    const newParam = param;

    if (newParam.updateType === this.yunwei.wz10) {
      newParam.updateType = "";
    }

    if (newParam.frameWork === this.yunwei.wz10) {
      newParam.frameWork = "";
    }

    if (newParam.smallVersion === this.yunwei.wz10) {
      // 增加小版本号
      newParam.smallVersion = "";
    }
    // 城市id格式化
    newParam.cityId =
      newParam.cityId === undefined
        ? ""
        : newParam.cityId
            .toString()
            .slice(
              newParam.cityId.toString().lastIndexOf(",") + 1,
              newParam.cityId.toString().length,
            );

    this.setState({
      tableParam: param,
    });
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      this.setState({
        currentParam: newParam,
      });
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "wareSourceStubSearchTable", newParam);
    }
  };

  // 更新frameType
  updateFramType = () => {
    fetchHandler(getStubInfoList, {
      stubId: this.stubInfoData.key,
    }).then((res) => {
      if (res && (res.code === "success" || res.code === "ok")) {
        this.setState({
          frameType: res.data[0].updateType,
          frameWork: res.data[0].frameWork,
        });
      }
    });
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable config={this.tableConfig} />
        </div>

        <Modal
          title={this.internationalization.btn4}
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => {
            this.modalVisibleAction("seeDetailVisible", false);
          }}>
          <StubDetailInfo stubInfoData={this.stubInfoData} />
        </Modal>

        <Modal
          title={this.internationalization.btn6}
          visible={this.state.seeStubStatusVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubStatusVisible", false);
          }}>
          <StubStatusUpdate
            stubId={this.state.stubId}
            onCancel={() => {
              this.setState({ seeStubStatusVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wareSourceStubSearchTable");
            }}
          />
        </Modal>

        <Modal
          title={this.internationalization.btn7}
          visible={this.state.seeParamsConfigVisible}
          footer={null}
          destroyOnClose
          width="1100px"
          onCancel={() => {
            this.modalVisibleAction("seeParamsConfigVisible", false);
          }}>
          <StubParamsConfig
            stubId={this.state.stubId}
            stubGroupName={this.state.stubGroupName}
            devType={this.state.devType}
          />
        </Modal>

        <Modal
          title={this.internationalization.wz7}
          visible={this.state.getFrameWorkVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("getFrameWorkVisible", false);
          }}>
          <GetFrameWorkEdition
            endModal={() => {
              console.log("GetFrameWorkEdition End");
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("getFrameWorkVisible", false);
            }}
            stubId={this.state.stubId}
            onCancel={() => {
              this.modalVisibleAction("getFrameWorkVisible", false);
            }}
          />
        </Modal>
        <Modal
          title={this.internationalization.wz8}
          visible={this.state.frameWorkUpdateVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("frameWorkUpdateVisible", false);
            // RefreshGrid(this.context.store, 'stubSearchTable', this.state.currentParam);
          }}>
          <FrameWorkUpdate
            record={this.stubInfoData || {}}
            updateFramType={() => {
              this.updateFramType();
            }}
            frameWorkUpdateFunc={() => {
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              this.setState({
                progressVisible: true,
              });
            }}
            errorHandler={() => {
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              this.setState({
                updateStatus: "error",
                progressVisible: true,
              });
            }}
            stubId={this.state.stubId}
            frameType={this.state.frameType}
            frameWork={this.state.frameWork}
            smallVersion={this.state.smallVersion} // 增加小版本号
            stubGroupName={this.state.stubGroupName}
            onCancel={() => {
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              // RefreshGrid(this.context.store, 'stubSearchTable', this.state.currentParam);
            }}
            devType={this.state.devType}
          />
        </Modal>
        <Modal
          title="状态日志"
          visible={this.state.statusLogVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("statusLogVisible", false);
          }}>
          <StubStatusLog stubIdData={this.stubInfoData && this.stubInfoData.key} />
        </Modal>
        <Modal
          visible={this.state.progressVisible}
          destroyOnClose
          footer={null}
          onCancel={() => {
            this.setState({ progressVisible: false });
          }}
          title="升级进度">
          <UpdateProgress record={this.stubInfoData} updateStatus={this.state.updateStatus} />
          <div style={{ textAlign: "center", marginTop: "24px" }}>
            <Button type="primary" onClick={() => this.setState({ progressVisible: false })}>
              隐藏
            </Button>
          </div>
        </Modal>
      </div>
    );
    return Content;
  }
}

export default injectIntl(WareSourceStubList);
WareSourceStubList.propTypes = {
  // tableKey: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/waresourceStubList.js